import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMoleculerComponent } from './simple-icons-moleculer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMoleculerComponent ],
    exports:      [ SimpleIconsMoleculerComponent ],
    bootstrap:    []
})
export class SimpleIconsMoleculerModule {}
